export const getPerformantCampaignState = (state: Record<string, any>) =>
  state.iterableGoals.goalAnalytics.performantCampaigns;
